// src/utils/getTimeLeft.ts

export function getTimeLeft(validUntil: string | undefined): string | null {
    if (!validUntil) return null;
  
    const end = new Date(validUntil);
    if (isNaN(end.getTime())) return null;
  
    const now = new Date();
    const diff = end.getTime() - now.getTime();
    if (diff <= 0) return null;
  
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
  
    if (days > 0) return `${days}d left`;
    if (hours > 0) return `${hours}h ${minutes}m left`;
    return `${minutes} minutes left`;
  }
  